import { useEffect, useState } from "react";

const checkIsInsideMobileWebview = () =>
  Boolean(
    window.webview?.isInsideMobileWebview ||
    window.webview?.isComingFromReactNativeWebview,
  );

// The React Native bridge injects `window.webview` asynchronously after the
// JS bundle evaluates. On slow devices or under JS thread contention the flag
// may arrive later than expected, so we cannot rely on a single one-shot check.
//
// Strategy: poll every POLL_INTERVAL_MS up to MAX_POLLS times (total
// MAX_POLLS * POLL_INTERVAL_MS ms). We stop as soon as the flag is detected to
// avoid any unnecessary work once the webview context is confirmed.
const POLL_INTERVAL_MS = 100;
const MAX_POLLS = 10; // 10 × 100 ms = 1 000 ms total polling window

export const useMobileWebviewDetection = () => {
  const [isInsideMobileWebview, setIsInsideMobileWebview] = useState(
    checkIsInsideMobileWebview,
  );
  const [hasCompletedCheck, setHasCompletedCheck] = useState(
    checkIsInsideMobileWebview,
  );

  useEffect(() => {
    if (isInsideMobileWebview) return;

    let pollCount = 0;

    const intervalId = setInterval(() => {
      pollCount += 1;

      const isDetected = checkIsInsideMobileWebview();

      if (isDetected) {
        setIsInsideMobileWebview(true);
        setHasCompletedCheck(true);
        clearInterval(intervalId);
        return;
      }

      if (pollCount >= MAX_POLLS) {
        setHasCompletedCheck(true);
        clearInterval(intervalId);
      }
    }, POLL_INTERVAL_MS);

    return () => clearInterval(intervalId);
  }, [isInsideMobileWebview]);

  return { hasCompletedCheck, isInsideMobileWebview };
};

export const useIsInsideMobileWebview = () =>
  useMobileWebviewDetection().isInsideMobileWebview;
